module.exports = __webpack_public_path__ + "img/ef10d258fcf0b704fcaf5ba22d9e1725.png";